/** Keep repeated values without tying their identity to their array position. */
export function occurrenceKeys<T>(items: readonly T[], identity: (item: T) => string): {key: string; item: T}[] {
   const seen = new Map<string, number>();
   return items.map(item => {
      const base = identity(item);
      const count = (seen.get(base) ?? 0) + 1;
      seen.set(base, count);
      return {key: JSON.stringify([base, count]), item};
   });
}

export function valueKey(value: unknown): string {
   if (value !== null && typeof value === "object" && !Array.isArray(value) && "id" in value && typeof value.id === "string" && value.id) return `id:${value.id}`;
   if (typeof value === "string") return `string:${value}`;
   if (typeof value === "number") return `number:${value}`;
   if (typeof value === "bigint") return `bigint:${value.toString()}`;
   if (typeof value === "boolean") return `boolean:${value}`;
   if (value === undefined) return "undefined";
   if (value === null) return "null";
   try {
      return `json:${JSON.stringify(value)}`;
   } catch {
      return "unserializable";
   }
}
